/* ============================================================
   Install video — click-to-play for the dedicated how-to player.
   Paired with sections/install-video.liquid + section-install-video.css.

   The <video> ships with preload="none" and NO controls, so before play it is
   just a clean poster behind a branded teal play button. On press we add native
   controls, mark the wrapper is-playing (hides our button), and play() with
   sound — the click is the user gesture that permits audible playback.
   ============================================================ */
(function () {
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wire(root) {
    if (root.dataset.ivWired) return;
    var btn = root.querySelector('[data-iv-play]');
    var video = root.querySelector('video');
    if (!btn || !video) return;
    root.dataset.ivWired = '1';

    // Click the branded button → play WITH sound (the click is the user gesture).
    btn.addEventListener('click', function () {
      root.classList.add('is-playing');
      video.muted = false;
      // Reveal native controls only now (keeps the poster chrome-free pre-play).
      video.setAttribute('controls', '');
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
      // Move focus to the player for keyboard users.
      try { video.focus({ preventScroll: true }); } catch (e) { video.focus(); }
    });

    // Optional: muted autoplay when the player scrolls into view. Muted playback
    // is allowed without a user gesture; native controls are shown so the visitor
    // can unmute/seek. Skipped for reduced-motion (falls back to click-to-play).
    if (root.dataset.ivAutoplay === '1' && !reduceMotion && 'IntersectionObserver' in window) {
      root.classList.add('is-playing'); // hide the branded button — it auto-plays
      video.muted = true;
      video.setAttribute('controls', '');
      var started = false;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
              started = true;
            } else if (started) {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );
      io.observe(root);
    }
  }

  function scan() {
    document.querySelectorAll('[data-install-video]').forEach(wire);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  // Theme editor: re-wire when this section is (re)loaded.
  document.addEventListener('shopify:section:load', scan);
})();
